import EventEmitter from "./utils/EventEmitter";

export default class CustomPager extends EventEmitter {
    constructor(element) {
        super();

        this.el = element

        // Options
        this.itemPerPage = this.el.dataset.itemPerPage

        this.pagination = this.el.querySelector('.pager')

        this.initPages()
    }

    initPages() {
        this.pages = Array.from(this.el.querySelectorAll('.item'))

        // Si on a moins de pages que le nombre d'items par page, on affiche toutes les pages et on ne crée pas de pagination
        if (this.pages.length <= this.itemPerPage) {
            return
        }

        this.pages.forEach((page) => {
            page.classList.add('u-none')
        })

        this.pages.slice(0, this.itemPerPage).forEach((page) => {
            page.classList.remove('u-none')
        })

        this.createPagination()
    }

    createPagination() {
        const totalItems = this.el.querySelectorAll('.item').length

        const totalPages = Math.ceil(totalItems / this.itemPerPage)

        for (let i = 1; i <= totalPages; i++) {
            const item = document.createElement('div')
            item.classList.add('page-item')

            const a = document.createElement('a')
            a.classList.add('page-link')
            a.setAttribute('href', '#')
            a.setAttribute('data-page', i)
            a.innerHTML = i

            item.appendChild(a)

            this.pagination.appendChild(item)
        }

        this.pagination.querySelector('.page-item:first-child').classList.add('is-active')

        // add prev and next buttons
        const prev = document.createElement('div')
        prev.classList.add('page-item--prev')
        prev.innerHTML = '<a class="pager-prev" href="#" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a>'
        this.pagination.insertBefore(prev, this.pagination.firstChild)

        const next = document.createElement('div')
        next.classList.add('page-item--next')
        next.innerHTML = '<a class="pager-next" href="#" aria-label="Next"><span aria-hidden="true">&raquo;</span></a>'
        this.pagination.appendChild(next)

        this.events()
    }

    events() {
        this.pagination.querySelectorAll('.page-link').forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault()
                this.goToPage(e.target.dataset.page)
            })
        })

        // Handle prev and next buttons events
        this.pagination.querySelector('.page-item--prev').addEventListener('click', (e) => {
            e.preventDefault()

            const currentPage = parseInt(this.pagination.querySelector('.page-item.is-active .page-link').dataset.page)

            if (currentPage > 1) {
                this.goToPage(currentPage - 1)
            }
        })

        this.pagination.querySelector('.page-item--next').addEventListener('click', (e) => {
            e.preventDefault()

            const currentPage = parseInt(this.pagination.querySelector('.page-item.is-active .page-link').dataset.page)

            if (currentPage < this.pagination.querySelectorAll('.page-link').length) {
                this.goToPage(currentPage + 1)
            }
        })
    }

    goToPage(page) {
        this.pagination.querySelector('.page-item.is-active').classList.remove('is-active')
        this.pagination.querySelector(`.page-link[data-page="${page}"]`).parentNode.classList.add('is-active')

        this.pages.forEach((page) => {
            page.classList.add('u-none')
        })

        this.pages.slice((page - 1) * this.itemPerPage, page * this.itemPerPage).forEach((page) => {
            page.classList.remove('u-none')
        })
    }
}
